import { Illustration, Text, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

export const EmptyListNotFound: React.FC = () => {
  return (
    <VStack space={Spacing['stack.quarck']} alignItems="center">
      <Illustration name="NotFoundIllustration" />
      <Text textAlign="center" variant="bold">
        Nenhum resultado corresponde à sua pesquisa
      </Text>
      <Text textAlign="center">Por favor, verifique o campo informado e tente novamente.</Text>
    </VStack>
  );
};
